import {
  type I18nTranslation,
  useTranslation as _useTranslation,
} from '@crehana/i18n';

import { PAGE_KEY } from './constants';
import { en } from './locale-en';
import { es } from './locale-es';
import { pt } from './locale-pt';
import type { TKeys } from './types';

const locales: I18nTranslation = { es, pt, en };

export const useSuccessionCoverageTranslation = () => {
  const result = _useTranslation<TKeys>(PAGE_KEY);
  return result;
};

export const useSuccessionCoverageBundle = () => {
  const { addResourceBundle } = useSuccessionCoverageTranslation();
  addResourceBundle(locales);
};
